export default "__VITE_ASSET__BGYxLGgw__"